import Handlebars from "handlebars";
import downloadFiles from "@/services/download-files";

var soapEnvelopeTemplate = Handlebars.compile(`URL: https://[Hostname]/Service.asmx

HTTP Request:
POST /Service.asmx HTTP/1.1
Host: [Hostname]
Content-type: text/xml; charset=utf-8
SOAPAction: Create

<Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
    <Header>
        {{#if accessTokenAuthorization}}<h:fueloauth xmlns="http://exacttarget.com" xmlns:h="http://exacttarget.com">[Access Token]</h:fueloauth>{{else}}<Security xmlns="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd">
            <UsernameToken>
                <Username>[User Name]</Username>
                <Password>[Password]</Password>
            </UsernameToken>
        </Security>{{/if}}
    </Header>
    <Body>
        <CreateRequest xmlns="http://exacttarget.com/wsdl/partnerAPI">
            <Options>
                <RequestType>Synchronous</RequestType>
            </Options>
            <Objects xsi:type="TriggeredSend">
                <PartnerKey xsi:nil="true"/>
                <ObjectID xsi:nil="true"/>
                <TriggeredSendDefinition>
                    <PartnerKey xsi:nil="true"/>
                    <ObjectID xsi:nil="true"/>
                    <CustomerKey>{{data.properties.trigger_properties.external_key}}</CustomerKey>
                </TriggeredSendDefinition>
                <Subscribers>
                    <PartnerKey xsi:nil="true"/>
                    <ObjectID xsi:nil="true"/>
                    <EmailAddress>[EmailAddress]</EmailAddress>
                    <SubscriberKey>[SubscriberKey]</SubscriberKey>{{#each attributes}}
                    <Attributes>
                        <Name>{{Name}}</Name>
                        <Value>[{{Name}}]</Value>
                    </Attributes>{{/each}}
                </Subscribers>
            </Objects>
        </CreateRequest>
    </Body>
</Envelope>`);

export var TriggerSoapEnvelope = function(component) {
    this.component = component;
};
Object.assign(
    TriggerSoapEnvelope.prototype,
    {
        make: function(data, useAccessToken) {
            var attributes = [];
            data.dataExtension.forEach((field) => {
                if (!field["template_field"]) {
                    attributes.push({
                        "Name": field["field_name"]
                    });
                }
            });
            return (
                soapEnvelopeTemplate({
                    data: data,
                    attributes: attributes,
                    accessTokenAuthorization: (
                        (useAccessToken.toString().toLowerCase() == "true") ?
                        true :
                        false
                    )
                })
            );
        }
    }
);
export default function(triggers, form, component) {
    var samples = [];
    var triggerSoapEnvelope = new TriggerSoapEnvelope(component);
    triggers.forEach((trigger) => {
        samples.push({
            name: `${trigger.data.properties.trigger_properties.name}.SOAP_ENVELOPE.xml`,
            content: triggerSoapEnvelope.make(trigger.data, form.useAccessToken),
            type: "application/xml;charset=utf-8"
        });
    });
    return downloadFiles(samples, "SOAP_Envelopes.zip");
}